import React from "react";
import { TRUST_LOGOS } from "@/data/content";

export const TrustBar = () => {
  const items = [...TRUST_LOGOS, ...TRUST_LOGOS];
  return (
    <section data-testid="trust-logos" className="border-y border-amber-200/40 bg-ivory-light/70 py-8">
      <p className="mb-6 text-center text-xs font-semibold uppercase tracking-[0.25em] text-charcoal-soft/70">
        Regulated · Allocated · Insured
      </p>
      <div className="relative overflow-hidden no-scrollbar [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]">
        <div className="flex w-max animate-marquee items-center gap-16 px-8">
          {items.map((logo, i) => (
            <div key={i} className="flex shrink-0 flex-col items-start opacity-60 transition-opacity hover:opacity-100">
              <span className="font-serif text-2xl tracking-tight text-charcoal">{logo.name}</span>
              <span className="text-[11px] uppercase tracking-[0.18em] text-charcoal-soft">{logo.sub}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
